<template>
  <div class="listswitching">
    <div
      :style="{
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <div
        v-if="datas.isShowType"
        class="goods_type_con"
        :style="{
          '--lineColor': datas.typeLineColor,
        }"
      >
        <div
          v-for="(item, index) in tabList"
          :key="index"
          :class="[
            { goods_type_item_active: activeTab == item.Id },
            'goods_type_item',
          ]"
          :style="{
            color:
              activeTab == item.Id ? datas.wordColorActive : datas.wordColor,
            'font-size':
              (activeTab == item.Id ? datas.wordSizeActive : datas.wordSize) +
              'px',
            'font-weight': handleSetBoldStyle(
              activeTab == item.Id ? datas.isBoldActive : datas.isBold
            ),
            'font-style': handleSetTiltStyle(
              activeTab == item.Id ? datas.isTiltActive : datas.isTilt
            ),
            'text-decoration': handleSetUnderLineStyle(
              activeTab == item.Id ? datas.isUnderLineActive : datas.isUnderLine
            ),
          }"
          @click="handleChangeType(item.Id)"
        >
          {{ item.Name }}
        </div>
      </div>
      <section
        v-if="datas.styleType === 1 || datas.styleType === 3"
        :class="[
          datas.styleType === 1 ? 'goods_list_con1' : '',
          datas.styleType === 3 ? 'goods_list_con3' : '',
        ]"
        class="goods_list_con"
      >
        <div
          v-for="(item, index) in goodsList"
          :key="index"
          class="goods_item_con"
        >
          <!-- 视频图片 -->
          <div class="goods_img_con">
            <div v-if="handleSetShow(5)" class="person_count_down">x人成团</div>
            <img
              draggable="false"
              :src="
                item.imgUrl ? item.imgUrl : '@/assets/images/defaultPic2.png'
              "
              alt=""
            />
            <div v-if="handleSetShow(4)" class="time_count_down">
              <van-count-down :time="item.time" v-if="item.DrawTicketItems[0].SaleStatusId==0" />
              <div v-else >{{item.DrawTicketItems[0].SaleStatusId==1?'未开始':item.DrawTicketItems[0].SaleStatusId==2?'已结束':'已售罄'}} </div>
            </div>
          </div>

          <!-- 内容 -->
          <div class="goods_info_con">
            <div>
              <!-- 名称 -->
              <div class="name_con ellipsis-con">{{ item.TicketName }}</div>
              <!-- 销量 -->
              <div v-if="handleSetShow(3)" class="sale_count_con">
                已售 {{ item.allSaleNumber }}
              </div>
            </div>

            <div>
              <div class="goods_money_con">
                <div>
                  <span class="price_con">￥{{ item.GrouponPrice }}</span>
                  <span v-if="handleSetShow(1)" class="origin_price_con"
                    >￥{{ item.MarketPrice }}</span
                  >
                </div>

                <div
                  v-if="handleSetShow(2)"
                  class="buy_btn_con"
                  :style="{ background: datas.buyBtnColor }"
                  @click="onCheckDetail(item.Id)"
                >
                  购买
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="datas.styleType === 2"
        class="goods_list_con goods_list_con2"
      >
        <div
          v-for="(item, index) in goodsList"
          :key="index"
          class="goods_item_con"
        >
          <!-- 视频图片 -->
          <div class="goods_img_con">
            <div v-if="handleSetShow(5)" class="person_count_down">x人成团</div>
            <img
              draggable="false"
              :src="
                item.imgUrl ? item.imgUrl : '@/assets/images/defaultPic2.png'
              "
              alt=""
            />
            <div v-if="handleSetShow(4)" class="time_count_down">
             <van-count-down :time="item.time" v-if="item.DrawTicketItems[0].SaleStatusId==0" />
              <div v-else >{{item.DrawTicketItems[0].SaleStatusId==1?'未开始':item.DrawTicketItems[0].SaleStatusId==2?'已结束':'已抢完'}} </div>
            </div>
          </div>

          <div class="goods_info_con">
            <div>
              <!-- 名称 -->
              <div class="name_con ellipsis-con">{{ item.TicketName }}</div>
              <!-- 销量 -->
              <div v-if="handleSetShow(3)" class="sale_count_con">
                已售 {{ item.allSaleNumber }}
              </div>
            </div>

            <div>
              <div class="goods_money_con">
                <div>
                  <span class="price_con">￥{{ item.GrouponPrice }}</span>
                  <span v-if="handleSetShow(1)" class="origin_price_con"
                    >￥{{ item.MarketPrice }}</span
                  >
                </div>

                <div
                  v-if="handleSetShow(2)"
                  class="buy_btn_con"
                  :style="{ background: datas.buyBtnColor }"
                  @click="onCheckDetail(item.Id)"
                >
                  购买
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getGroupClassifyType, getGroupGoodsList } from "@/api/activity";

export default {
  name: "Listswitching",
  props: {
    datas: Object,
  },
  data() {
    return {
      tabList: [],
      activeTab: "",
      goodsList: [],
    };
  },
  watch: {
    // "datas.tabColor": function() {
    //   this.$refs[this.listSwitchName].querySelector(
    //     ".van-tabs__line"
    //   ).style.backgroundColor = this.datas.tabColor;
    //   this.$refs[this.listSwitchName].querySelector(
    //     ".van-sidebar-item--select"
    //   ).style.borderColor = this.datas.tabColor;
    // },
    // "datas.commoditylisttype": function() {
    //   if (this.datas.commoditylisttype === 2) {
    //     this.$refs[this.listSwitchName].querySelector(
    //       ".van-sidebar-item--select"
    //     ).style.borderColor = this.datas.tabColor;
    //   }
    // },
    // "datas.showContents": function() {
    // },
    // "datas.commoditycornertype": function() {
    //   this.tagPositionStyle();
    // }
  },
  created() {},
  mounted() {
    this.vpnId = this.$store.state.vpnId;
    this.handleGetType();
    this.$nextTick(() => {
      // if (this.$refs[this.listSwitchName]) {
      //   this.$refs[this.listSwitchName][0].querySelector(
      //     ".van-sidebar-item--select"
      //   ).style.borderColor = this.datas.tabColor;
      // }
    });
  },
  methods: {
    handleGetType() {
      getGroupClassifyType({ id: this.vpnId }).then((res) => {
        let data = res;
        if (data instanceof Array && data.length > 0) {
          this.tabList.unshift({ Name: "全部", Id: "", goodsList: [] });
          data.map((item) => {
            item.goodsList = [];
            this.tabList.push(item);
          });
          this.getProducts();
        }
      });
    },
    // 产品列表请求方法
    getProducts() {
      let params = {
        query: {
          // vpnId: '299792465',
          VpnId: this.vpnId,
          EventTypeId:this.datas.activityType,
          ProductTypeId: this.activeTab,
        },
        pager: {
          pageindex: 0,
          pagesize: this.datas.showNumber,
        },
      };
      getGroupGoodsList(params)
        .then((res) => {
          let data = res.Items;
          if (data instanceof Array) {
            data.map((item) => {
              const ticketItem =
                item.DrawTicketItems && item.DrawTicketItems[0];
              // 产品列表图片
              const imgArr = ticketItem.Claims;
              if (imgArr instanceof Array && imgArr.length > 0) {
                const imgItem = imgArr.find((subItem) => subItem.TypeId === 0);
                if (imgItem) {
                  item.imgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
                }
                // imgArr.map((subItem) => {
                //   if (subItem.TypeId === 0) {
                //     item.imgUrl = `${subItem.CdnUrl}/${subItem.Value}`;
                //   }
                // });
              }
               if (ticketItem.SaleStatusId == 1) {
          let timeNum =
            new Date(item.StartTime.replace(/-/g, "/")) - new Date();

          item.time = timeNum;
        } else if (ticketItem.SaleStatusId == 0) {
          let timeNum = new Date(item.EndTime.replace(/-/g, "/")) - new Date();

          item.time = timeNum;
        }
              item.TicketName = ticketItem.TicketName;
              item.GrouponPrice = ticketItem.GrouponPrice;
              item.MarketPrice = ticketItem.MarketPrice;
              item.VirtualSaleNumber = ticketItem.VirtualSaleNumber;
              const realSaleNumber = ticketItem.AddupStock - ticketItem.RealtimeStock;
								item.allSaleNumber = realSaleNumber + ticketItem.VirtualSaleNumber || 0;
            });
            this.goodsList = data;
            // // 添加产品数据到对应的tabList中
            // this.tabList.map((item) => {
            //   if (item.Id === this.activeTabName) {
            //     if (this.pageIndex > 1) {
            //       // 合并
            //       item.goodsList = item.goodsList.concat(data);
            //     } else {
            //       // 覆盖
            //       item.goodsList = data;
            //     }
            //   }
            // });
            // // 没有更多数据时结束上拉加载事件
            // if (data.length < this.pageSize || data.length === 0) {
            //   this.finished = true;
            // }
            // // 加载结束
            // this.loading = false;

            // // 离开首页再返回时，重新定位到离开时的位置
            // let historyScollTop = this.$store.state.historyScollTop;
            // console.log(historyScollTop);
            // if (historyScollTop) {
            //   this.$nextTick(() => {
            //     window.scrollTo(0, historyScollTop);
            //   });
            // }
          }
        })
        .catch((err) => {
          this.goodsList = [];
        });
    },
    handleChangeType(id) {
      this.activeTab = id;
      this.getProducts();
    },
    handleSetBoldStyle(data) {
      return data ? "bold" : "normal";
    },
    handleSetTiltStyle(data) {
      return data ? "italic" : "normal";
    },
    handleSetUnderLineStyle(data) {
      return data ? "underline" : "none";
    },
    handleSetShow(type) {
      return this.datas.showContents.includes(type);
    },
    // 查看产品详情
    onCheckDetail(productId) {
      this.$router.push({
        name: "FlashSalePage",
        params: { id: productId },
        query: {
          fromPage: "buy",
        },
      });
    },
    // 这里有个bug  当出现多个商品组件且同为类型3时  点击某一个商品组件会无法匹配 .van-sidebar-item 个数
    // treeSelect(index) {
    //   setTimeout(() => {
    //     this.$refs[this.listSwitchName]
    //       .querySelectorAll(".van-sidebar-item")
    //       .forEach((item, i) => {
    //         if (i !== index) {
    //           item.style.borderColor = "transparent";
    //         }
    //       });
    //     this.$refs[this.listSwitchName].querySelector(
    //       ".van-sidebar-item--select"
    //     ).style.borderColor = this.datas.tabColor;
    //   });
    // },
  },
};
</script>

<style scoped lang="scss">
.listswitching {
  position: relative;
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  // padding: 10px 0;
  .goods_list_con {
    .goods_item_con {
      box-shadow: 0px 3px 10px 0px rgba(213, 213, 213, 0.5);
      background: #fff;
      border-radius: 15px;
      overflow: hidden;
    }
    &.goods_list_con1 {
      display: flex;
      width: 100%;
      overflow-x: auto;
      // &::-webkit-scrollbar {
      //   height: 6px;
      // }
      // &::-webkit-scrollbar-thumb {
      //   background: #e1e3e9;
      //   border-radius: 20px;
      // }
      .goods_item_con {
        width: 310px;
        flex-shrink: 0;
        margin-right: 16px;
      }
    }
    &.goods_list_con3 {
      display: flex;
      flex-wrap: wrap;
      .goods_item_con {
        width: 48.9%;
        margin-right: 16px;
        margin-bottom: 16px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        .goods_img_con {
          height: 320px;
        }
      }
    }
    &.goods_list_con2 {
      .goods_item_con {
        display: flex;
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0;
        }
        .goods_img_con {
          width: 256px;
          height: 240px;
        }
        .goods_info_con {
          flex: 1;
          padding: 15px 20px;
          .goods_money_con {
            .price_con {
              font-size: 36px;
            }
          }
        }
      }
    }
    .goods_img_con {
      height: 256px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .person_count_down {
        position: absolute;
        top: 3px;
        background: linear-gradient(to right, #c29263, #e5c9ab);
        color: #fff;
        padding: 5px 10px;
        border-radius: 0 15px 15px 0;
        font-size: 24px;
      }
      .time_count_down {
        position: absolute;
        bottom: 0;
        background: linear-gradient(to right, #c29263, #e5c9ab);
        color: #fff;
        text-align: center;
        padding: 7px 0;
        width: 100%;
      }
    }
    .goods_info_con {
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name_con {
        font-size: 26px;
        color: #333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .sale_count_con {
        color: #333;
        font-size: 24px;
      }
      .goods_money_con {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        .price_con {
          color: #cca567;
          font-size: 24px;
          margin-right: 5px;
        }
        .origin_price_con {
          text-decoration: line-through;
          color: #999;
          font-size: 24px;
        }
        .buy_btn_con {
          padding: 10px 20px;
          border-radius: 30px;
          color: #fff;
          font-size: 24px;
        }
      }
    }
  }
  .goods_type_con {
    display: flex;
    margin-bottom: 10px;
    .goods_type_item {
      flex: 1;
      text-align: center;
      padding: 15px 0;
      position: relative;
      &.goods_type_item_active::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        height: 3px;
        width: 30px;
        background: var(--lineColor);
        margin-left: -15px;
      }
    }
  }
}
</style>
